<template>
    <el-select
        v-model="currency"
        filterable
        @change="updateCurrency"
        v-if="!loading"
        >
        <el-option-group
            v-for="currency in currenciesAvailable"
            :key="currency.label"
            >

            <el-option
                v-for="option in currency.options"
                :key="option.id"
                :label="option[mode]"
                :value="option.name"
                >
                <span class="fleft">{{ option.longname }}</span>
                <span class="fright fs-3 gray-60">{{ option.symbol }}</span>
            </el-option>

        </el-option-group>
    </el-select>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('system');

export default {
    props: {
        mode: {
            type: String,
            required: false,
            default: 'longname',
            validator: function (value) {
                return ['longname', 'symbol'].includes(value)
            }
        },
        value: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            loading: false,
            currenciesAvailable : [],
            topsCurrencies : ['EUR', 'USD', 'YEN', 'GBP'],
            currency: this.value
        }
    },
    created(){
        if (this.value) {
            let found = this.allCurrencies.find(currency => currency.name === this.value);
            if (!found) {
                this.currency = this.topsCurrencies[0];
                this.updateCurrency();
            }
        }
        this.sortCurrencies(this.allCurrencies);
    },
    computed: {
        ...mapState({
            allCurrencies: 'currencies'
        }),
    },
    methods: {
        updateCurrency() {
            this.$emit('input', this.allCurrencies.find(currency => currency.name === this.currency));
        },
        sortCurrencies(data) {
            data.sort(function(a,b) {
                if (a.longname < b.longname) {return -1;}
                if (a.longname > b.longname) {return 1;}
                return 0;
            })

            let tops    = [];
            let others  = [];
            data.forEach(currency => {
                if (this.topsCurrencies.includes(currency.name)) {
                    tops.push(currency);
                } else {
                    others.push(currency);
                }
            });

            this.currenciesAvailable = [
                {
                    label   : 'tops',
                    options : tops
                },
                {
                    label   : 'others',
                    options : others
                }
            ];
        }
    }
}
</script>
